<template>
  <div v-if="!mySelf" class="chat-message">
    <w-navigation
      v-if="message.user || message.permalink"
      :object="message"
      :full="false"
      :params="{
        name: 'ProfilePage',
        params: {
          slug: getProfileSlug(message)
        }
      }"
    >
      <template #link>
        <img
          :src="getUserImageUrl(message)"
          :alt="message.user_name || message.full_name"
          class="user-message-image"
          @error="
            $event.target.src = require('@/assets/images/placeholder-user.svg')
          "
        />
      </template>
    </w-navigation>
    <img
      v-else
      :src="getUserImageUrl(message)"
      :alt="message.user_name || message.full_name"
      class="user-message-image"
      @error="
        $event.target.src = require('@/assets/images/placeholder-user.svg')
      "
    />
    <div class="message-container">
      <p
        class="message-item-text"
        v-html="decodeChatMessage(message.text || message.message)"
      ></p>
      <span>{{ formatHourSimple(message.created || message.timestamp) }}</span>
    </div>
  </div>
  <div v-else class="chat-message chat-message--self">
    <div class="message-container self">
      <p
        class="message-item-text"
        v-html="decodeChatMessage(message.text || message.message)"
      ></p>
      <span>{{ formatHourSimple(message.created || message.timestamp) }}</span>
    </div>
    <img
      :src="getUserImageUrl(message)"
      :alt="message.user_name || message.full_name"
      class="user-message-image"
      @error="
        $event.target.src = require('@/assets/images/placeholder-user.svg')
      "
    />
  </div>
</template>

<script setup>
import WNavigation from "@/components/general/ui/WNavigation.vue";

import { toRefs, computed } from "vue";
import { formatHourSimple } from "@/plugins/date-formater";
import { useUser } from "@/composables/useUser";
import { useChat } from "@/composables/useChat";

const { decodeChatMessage } = useChat();
const { userDetail } = useUser();

const props = defineProps({
  message: { type: Object, default: () => {} }
});

const mySelf = computed(
  () =>
    userDetail.value.id === props.message?.user?.id ||
    props.message.senderId === userDetail.value.id.toString()
);

const getUserImageUrl = element => {
  if (element.user) {
    return element.user.thumbnails?.s_sq
      ? element.user.thumbnails.s_sq
      : element.user.image_url ||
          element?.user.user_image ||
          require("@/assets/images/placeholder-user.svg");
  } else {
    return element.image_url || require("@/assets/images/placeholder-user.svg");
  }
};

const getProfileSlug = message => {
  const permalink = message?.user?.permalink || message?.permalink || undefined;
  if (!permalink) return "";
  return permalink
    .split("/")
    .filter(item => item)
    .splice(-1)[0];
};
</script>

<style lang="scss" scoped>
.chat-message {
  @apply flex flex-row ml-2;
  overflow-y: auto;
  height: auto;
  margin-top: 10px;
  &--self {
    margin-right: 0.5rem;
  }

  &::-webkit-scrollbar {
    display: none;
  }
  .user-message-image {
    height: 34px;
    width: 34px;
    border-radius: 50%;
    max-width: none;
    object-fit: cover;
  }
  .message-container:is(.self) {
    @apply ml-auto mr-2;
    background-color: $inputLigthBackground;
    span {
      color: $scrollMainColor;
      bottom: 3px;
    }
  }
  .message-item-text {
    text-wrap: pretty;
    word-break: keep-all;
  }
  .message-container {
    @apply ml-2 px-4 pt-1 pb-3 bg-valhalla;
    border-radius: 5px;
    position: relative;
    max-width: 80%;
    word-break: break-all;
    span {
      font-weight: 300;
      font-size: 10px;
      line-height: 10px;
      color: $textSubtitle;
      position: absolute;
      bottom: 3px;
      right: 3px;
    }
    p {
      @apply mr-5;
    }
  }
}
</style>
